<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 36 36"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M31.75 29.3333C31.75 30.1771 31.066 30.8611 30.2222 30.8611L1.77795 30.8611C0.934168 30.8611 0.250187 30.1771 0.250187 29.3333C0.250187 28.4896 0.934168 27.8055 1.77795 27.8055L30.2222 27.8055C31.066 27.8055 31.75 28.4896 31.75 29.3333Z"
    fill="var(--black-color)"
    stroke="#F4F7FB"
    stroke-width="0.5"
  />
  <path
    d="M31.75 2.66682C31.75 3.5106 31.066 4.19458 30.2222 4.19458L1.77796 4.19458C0.934168 4.19458 0.250191 3.5106 0.250191 2.66682C0.250191 1.82303 0.934168 1.13906 1.77796 1.13906L30.2222 1.13906C31.066 1.13906 31.75 1.82304 31.75 2.66682Z"
    fill="var(--black-color)"
    stroke="#F4F7FB"
    stroke-width="0.5"
  />
  <path
    d="M17.5278 20.4445C17.5278 21.2883 16.8438 21.9723 16 21.9723L1.77789 21.9723C0.934103 21.9723 0.250122 21.2883 0.250122 20.4445C0.250122 19.6007 0.934099 18.9168 1.77789 18.9168L16 18.9168C16.8438 18.9168 17.5278 19.6007 17.5278 20.4445Z"
    fill="var(--black-color)"
    stroke="#F4F7FB"
    stroke-width="0.5"
  />
  <path
    d="M17.5278 11.5556C17.5278 12.3994 16.8438 13.0834 16 13.0834L1.77789 13.0834C0.934097 13.0834 0.250122 12.3994 0.250122 11.5556C0.250122 10.7118 0.934098 10.0279 1.77789 10.0279L16 10.0279C16.8438 10.0279 17.5278 10.7118 17.5278 11.5556Z"
    fill="var(--black-color)"
    stroke="#F4F7FB"
    stroke-width="0.5"
  />
  <path
    d="M30.9055 22.5228L30.9055 22.5228C31.4231 22.264 31.75 21.735 31.75 21.1563L31.75 10.4897C31.75 9.91101 31.4231 9.3821 30.9055 9.12329C30.3879 8.86448 29.7685 8.92026 29.3056 9.2675L29.3056 9.26751L22.1945 14.6008L22.1945 14.6008C21.8098 14.8892 21.5834 15.3421 21.5834 15.823C21.5834 16.3038 21.8098 16.7566 22.1945 17.0452L30.9055 22.5228ZM30.9055 22.5228C30.3879 22.7816 29.7685 22.7257 29.3056 22.3785C29.3056 22.3785 29.3056 22.3785 29.3056 22.3785L22.1945 17.0453L30.9055 22.5228ZM25.9241 15.623L25.6575 15.823L25.9241 16.023L28.2945 17.8008L28.6945 18.1008L28.6945 17.6008L28.6945 14.0453L28.6945 13.5453L28.2945 13.8453L25.9241 15.623Z"
    fill="var(--black-color)"
    stroke="#F4F7FB"
    stroke-width="0.5"
  />
</svg>
